<app-tab [items]="items" [selectedIndex]="selectedItemIndex" (onTabChange)="tabChange($event)"></app-tab>

<ng-template #usersTemplate>
  <app-dummy-data-users *ngIf="tabLoaded[0] || selectedItemIndex === 0"></app-dummy-data-users>
</ng-template>

<ng-template #doctorsTemplate>
  <app-dummy-data-scan *ngIf="tabLoaded[1] || selectedItemIndex === 1"></app-dummy-data-scan>
</ng-template>

<ng-template #appointmentsTemplate>
  <app-dummy-data-scan-appointments *ngIf="tabLoaded[2] || selectedItemIndex === 2"></app-dummy-data-scan-appointments>
</ng-template>

<ng-template #couponsTemplate>
  <app-dummy-data-coupons *ngIf="tabLoaded[3] || selectedItemIndex === 3"></app-dummy-data-coupons>
</ng-template>
